import React from 'react'
import { Link } from 'react-router-dom'
import AnimateIn from './AnimateIn'

function Footer() {
  return (
    <AnimateIn from="up" threshold={0.5}>
      <div className='sm:px-[90px] border-t border-f-border flex justify-between px-8 py-3'>
        <p className='text-[#343373] font-[500] text-[12px] sm:text-[16px]'>© Kelen Immigration Services Inc.</p>
        <p className='text-[#343373] font-[500] text-[12px] sm:text-[16px]'><Link to={'/privacy'}>Privacy Policy</Link></p>
      </div>
    </AnimateIn>
  )
}

export default Footer
